<!--人员总结-->
<template>
  <!--  <div v-if="dataNotNull" key="1" class="staffDiv" style="width: 100%; height: 100%">-->
  <!--    <div class="container1" style="margin:15px 0 0 20px; height: 100%;"></div>-->
  <!--  </div>-->

  <div v-if="dataNotNull" key="1" style="width: 100%; height: 100%;">
    <div class="title_con_staff">Total Staff Registered <br/>(By Project)
    </div>
    <dv-scroll-board :config="config" style="margin-top: 30px;margin-left:20px;width:330px;height:140px"/>
  </div>

  <div v-else key="2" style="width: 100%; height: 100%;">
    <div class="title_staff">Total Staff Registered <br/>(By Project)</div>
    <div class="zero_staff">No Data !</div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  props: ['cons_id'],
  name: "staff",
  data() {
    return {
      color: this.$store.state.color.chart_color,
      myChart: null,
      name: "staff",
      dataNotNull: false,//饼图改成列表时，由true改成了false
      config: {
        data: [],
        oddRowBGC: 'transparent',
        evenRowBGC: 'transparent',
        align: ['left', 'center'],
        columnWidth: [260, 70]
      },
    }
  },
  methods: {
    init() {
      // this.$root.charts.push(this.myChart)
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },
  mounted() {
    let postData = {
      cms_conid: window.localStorage.getItem('cons_id'),
      type: '1',
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }

    axios.post(this.$store.getters.getCmsServer + "DBConStaff", postData).then(resp => {
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      console.log(resp)
      if (errNo == "0") {
        this.dataNotNull = true
        var result = resp.data.result
        for (let i in result) {
          let res = []
          res.push(result[i].program_name)
          res.push(result[i].count.toString())
          this.config.data.push(res)
        }
      } else {
        this.dataNotNull = false
      }
    }).catch(error => {
      alert("DBConStaff.error:" + error)
      this.dataNotNull = false
    })
  }
  // mounted() {
  //   var that = this
  //   this.myChart = echarts.init(document.querySelector('.staffDiv .container1'))
  //   this.myChart.setOption({
  //     title: {
  //       text: "Total Staff Registered \n" + "(By Project)",
  //       textStyle: {
  //         color: '#FFF',
  //         fontSize: 16
  //       }
  //     },
  //     tooltip: {
  //       trigger: 'item',
  //       formatter: "{a} <br/>{b}: {c} ({d}%)"
  //     },
  //     legend: {
  //       orient: 'vertical',
  //       x: 'right',
  //       left: '45%',
  //       top: 'middle',
  //       itemGap: 10,
  //       itemHeight: '8',
  //       textStyle: {
  //         color: '#FFF',
  //         fontSize: '10'
  //       },
  //       data: []
  //     },
  //     series: [{
  //       name: 'Staff',
  //       data: [],
  //       type: 'pie',
  //       hoverOffset: 5,
  //       radius: ['35%', '55%'],
  //       center: ['20%', '50%'],
  //       label: {
  //         normal: {
  //           show: true,
  //           position: 'inside',
  //           formatter: '{c}'
  //         },
  //         emphasis: {
  //           show: true,
  //           textStyle: {
  //             fontSize: '15',
  //           }
  //         }
  //       },
  //       labelLine: {
  //         normal: {
  //           show: false
  //         }
  //       },
  //
  //       itemStyle: {
  //         normal: {
  //           color: function (params) {
  //             // var colorList = ['#B077F3', '#FD935C', '#C55EB2', '#628D53','#F1D15D']
  //             var colorList = that.$store.state.color.chart_color
  //             return colorList[params.dataIndex]
  //           }
  //         },
  //         //鼠标悬停时：
  //         emphasis: {
  //           shadowBlur: 10,
  //           shadowOffsetX: 0,
  //           shadowColor: 'rgba(0, 0, 0, 0.5)',
  //           borderWidth: 1,
  //         }
  //       }
  //     }],
  //   })
  //
  //   this.myChart.showLoading({
  //     text: '',
  //     color: '#66CCFF',
  //     maskColor: 'rgba(255, 255, 255, 0)',
  //   });
  //
  //   let postData = {
  //     cms_conid: window.localStorage.getItem('cons_id'),
  //     type: '1',
  //     user: window.localStorage.getItem("token_key"),
  //     token: window.localStorage.getItem('token')
  //   }
  //   axios.post(that.$store.getters.getCmsServer + "DBConStaff", postData).then(resp => {
  //     var errNo = resp.data.errno
  //     var errStr = resp.data.errstr_cn
  //     that.myChart.hideLoading()
  //     if (errNo == "0") {
  //       this.dataNotNull = true
  //       var legends = []
  //       var staff = []
  //       var result = resp.data.result;
  //       for (var i in result) {
  //         legends.push(result[i].program_name)
  //         staff.push({name: result[i].program_name, value: result[i].count})
  //       }
  //       that.myChart.setOption({
  //         legend: {
  //           data: legends
  //         },
  //         series: [{
  //           data: staff
  //         }]
  //       })
  //     } else {
  //       that.dataNotNull = false
  //     }
  //   }).catch(error => {
  //     alert(error)
  //     this.myChart.hideLoading()
  //     this.dataNotNull = false
  //   })
  // }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.title_con_staff
  width 100%
  height 10%
  text-align left
  font-weight bold
  font-size 16px
  color #FFF
  padding-top 17px
  padding-left 25px

.title_staff
  width 100%
  height 10%
  text-align left
  font-weight bold
  font-size 16px
  color #FFF
  padding-top 17px
  padding-left 25px

.zero_staff
  width 100%
  height 100%
  text-align center
  padding-top 15%
  font-size 28px
  color #6CF
</style>



// WEBPACK FOOTER //
// src/components/constractor/staff.vue